import type { Campaign } from '../campaignsApi';
import { useState } from 'react';
import { campaignGoogleProposals, type GoogleProposals } from '../googleProposals';
import { GoogleProposalFields } from './GoogleProposalFields';
import { GoogleActivePublication } from './GoogleActivePublication';
import './campaign-journey.css';

interface Props {
  campaign: Campaign; onGenerate: () => void; generating: boolean; error?: string; generated?: boolean;
  onSave: (proposals: GoogleProposals) => Promise<unknown>; saving: boolean; saveError?: string;
  init?: RequestInit;
}

export function GoogleSearchReview({ campaign, onGenerate, generating, error, generated, onSave, saving, saveError, init }: Props) {
  const [draft, setDraft] = useState<GoogleProposals>();
  const [saved, setSaved] = useState(false);
  const { headlines, descriptions, keywords } = draft || campaignGoogleProposals(campaign);
  async function save() {
    if (!draft) return;
    try { await onSave(draft); setDraft(undefined); setSaved(true); }
    catch { /* Mantém a edição para corrigir ou tentar novamente. */ }
  }
  return <section className="campaign-review-section">
    <h3>Google Ads · Revisão do anúncio de Pesquisa</h3>
    <p>O Google combina os títulos e descrições abaixo. As palavras-chave definem quando o anúncio pode aparecer. Imagens da Meta não fazem parte deste formato.</p>
    <div className="campaign-search-preview">
      <small>Prévia de uma combinação · Patrocinado</small>
      <span>{campaign.landing_url || 'Defina o site na etapa 1'}</span>
      <strong>{headlines.slice(0, 3).join(' | ') || 'Gere os títulos para revisar o anúncio'}</strong>
      <p>{descriptions.slice(0, 2).join(' ')}</p>
    </div>
    {draft ? <GoogleProposalFields value={draft} onChange={setDraft} disabled={saving} /> : <div className="campaign-review-columns">
      <div><h4>Títulos ({headlines.length})</h4><ul>{headlines.map((text, index) => <li key={index}>{text}</li>)}</ul></div>
      <div><h4>Descrições ({descriptions.length})</h4><ul>{descriptions.map((text, index) => <li key={index}>{text}</li>)}</ul></div>
      <div><h4>Palavras-chave ({keywords.length})</h4><ul>{keywords.map((text, index) => <li key={index}>{text}</li>)}</ul></div>
    </div>}
    {(!headlines.length || !descriptions.length || !keywords.length) && <p role="alert">Faltam textos ou palavras-chave. Edite manualmente ou gere propostas a partir do briefing.</p>}
    {campaign.google_campaign_id && <p>Os textos salvos no CRM podem ser ajustados e reenviados à publicação existente.</p>}
    {error && <p role="alert" className="campaign-channel-error">Não foi possível gerar as propostas: {error}</p>}
    {draft && <p>Alterações ainda não salvas. A prévia acompanha a edição.</p>}
    {saveError && draft && <p role="alert" className="campaign-channel-error">Não foi possível salvar: {saveError}</p>}
    {!draft && (saved || generated) && <p role="status">Propostas Google Ads salvas. Revise os textos antes de publicar.</p>}
    <div className="google-proposal-actions">
    {draft ? <>
      <button type="button" className="campaign-journey-button" disabled={saving} onClick={save}>{saving ? 'Salvando...' : 'Salvar alterações Google Ads'}</button>
      <button type="button" className="google-proposal-secondary" disabled={saving} onClick={() => setDraft(undefined)}>Cancelar edição</button>
    </> : <>
    <button type="button" className="campaign-journey-button" disabled={generating} onClick={() => { setDraft(campaignGoogleProposals(campaign)); setSaved(false); }}>Editar propostas Google Ads</button>
    <button type="button" className="google-proposal-secondary" disabled={generating} onClick={onGenerate}>
      {generating ? 'Gerando propostas...' : headlines.length ? 'Regerar propostas Google Ads' : 'Gerar propostas Google Ads'}
    </button>
    </>}
    </div>
    {campaign.google_campaign_id && !draft && !generating && !saving && <GoogleActivePublication
      key={JSON.stringify([campaign.id, headlines, descriptions, keywords])} campaign={campaign} init={init} />}
  </section>;
}
